module.exports = __webpack_public_path__ + "static/media/logoL.69cbfee8.png";